(function () {
  const LOG = true;
  const log = (...a) => LOG && console.log('[bc-filters]', ...a);

  // ieslēdz/izslēdz kaskādi:
  // true  = klikšķojot uz čipa, noņem TIKAI visus, kas nāk pēc viņa (pa labi), pašu atstāj
  // false = klikšķojot uz čipa, noņem TIKAI šo vienu filtru
  const CASCADE_CLEAR = true;

  // ---------- Helpers ----------
  const uniq = (arr) => Array.from(new Set(arr.filter(Boolean).map(s => s.trim()).filter(Boolean)));

  function decodeHTML(str) {
    const d = document.createElement('div');
    d.innerHTML = str;
    return d.textContent || d.innerText || '';
  }

  function getBreadcrumbContainer() {
    return document.querySelector('.breadcrumbs-wrap') ||
           document.querySelector('nav[aria-label*="Bread"], .breadcrumbs, .breadcrumb, nav.breadcrumbs, ol.breadcrumbs, ol.breadcrumb');
  }

  function getSecondCrumbEl(bc) {
    if (!bc) return null;
    return (
      bc.querySelector('li:nth-child(2) a, li:nth-child(2) span') ||
      bc.querySelector('a:nth-of-type(2), span:nth-of-type(2)')
    );
  }

  // pašreizējais Sort by (nerādām kā filtru)
  function getCurrentSortLabel() {
    const sel = document.querySelector('select[name="sort_by"]');
    if (sel && sel.options && sel.selectedIndex >= 0) {
      const txt = sel.options[sel.selectedIndex].text;
      if (txt) return decodeHTML(txt.trim());
    }
    const pressed = document.querySelector('[data-sortby] [aria-pressed="true"], .toolbar-sort [aria-pressed="true"]');
    if (pressed) {
      const t = pressed.textContent || pressed.innerText;
      if (t) return decodeHTML(t.trim());
    }
    return null;
  }
  function isInsideSortUI(el) {
    return !!el.closest('.toolbar-sort, .sorting, [data-sortby], .products-toolbar__sort, .sort-by, .js-sort, [name="sort_by"]');
  }

  // ---------- savākt aktīvos filtru avotus (secībā) ----------
  function collectActiveFilterSources() {
    const sources = [];
    const sortLabel = getCurrentSortLabel();
    let idx = 0;

    // čipi/pogas
    const chipSelectors = [
      '.active-facets__button',
      '[data-active-filters] .active-filter',
      '.selected-facets .selected-facet',
      '.active-filters .filter-active',
      '.facet-pill--active',
    ];
    chipSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        if (isInsideSortUI(el)) return;
        const labelNode = el.querySelector('span:not(.visually-hidden)') || el;
        const raw = (labelNode.textContent || '').trim();
        if (!raw) return;
        const label = decodeHTML(raw);
        if (sortLabel && label === sortLabel) return;
        sources.push({ idx: idx++, label, el, type: 'chip' });
      });
    });

    // atķeksētie inputi
    const inputSelectors = [
      '.facets__item input[type=checkbox]:checked',
      '.facets__item input[type=radio]:checked',
      '.facets input:checked',
    ];
    inputSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(input => {
        if (isInsideSortUI(input)) return;
        let labelEl = input.nextElementSibling;
        if (labelEl && labelEl.tagName === 'LABEL') {
          const maybe = labelEl.querySelector('.facet-checkbox__text, .facet-radio__text') || labelEl;
          const raw = (maybe.textContent || '').trim();
          if (!raw) return;
          const label = decodeHTML(raw);
          if (sortLabel && label === sortLabel) return;
          sources.push({ idx: idx++, label, el: input, type: 'input' });
        }
      });
    });

    // cena
    const minEl = document.querySelector('input[name*="price"][name$="gte"][value]:not([value=""])');
    const maxEl = document.querySelector('input[name*="price"][name$="lte"][value]:not([value=""])');
    if (minEl || maxEl) {
      const minV = minEl ? minEl.value : '';
      const maxV = maxEl ? maxEl.value : '';
      const label = `Price: ${minV || '0'}–${maxV || '∞'}`;
      sources.push({ idx: idx++, label, el: (minEl || maxEl), type: 'price' });
    }

    // de-dup pēc label (saglabā pirmo sastapto)
    const seen = new Set();
    return sources.filter(s => {
      if (seen.has(s.label)) return false;
      seen.add(s.label);
      return true;
    });
  }

  // vienas vienības noņemšana
  function triggerRemoveForSource(src) {
    try {
      if (src.type === 'chip') {
        src.el.click();
      } else if (src.type === 'input') {
        src.el.click();
      } else if (src.type === 'price') {
        const form = src.el.closest('form') || document.querySelector('.facets__form, form[action*="collections"]');
        const min = form && form.querySelector('input[name*="price"][name$="gte"]');
        const max = form && form.querySelector('input[name*="price"][name$="lte"]');
        if (min) { min.value = ''; min.dispatchEvent(new Event('change', { bubbles: true })); }
        if (max) { max.value = ''; max.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    } catch (e) { log('remove error', e); }
  }

  // ---------- update (idempotents) ----------
  function updateBreadcrumbs() {
    const bc = getBreadcrumbContainer();
    if (!bc) { log('No breadcrumb container'); return; }

    const crumb2 = getSecondCrumbEl(bc);
    if (!crumb2) { log('No second crumb'); return; }

    const baseTextStored = crumb2.getAttribute('data-base-text');
    const baseText = baseTextStored && baseTextStored.trim()
      ? baseTextStored.trim()
      : ((crumb2.textContent || '').trim());

    const li = crumb2.closest('li') || crumb2.parentNode;

    const sources = collectActiveFilterSources(); // secībā
    const labels  = sources.map(s => s.label);
    const MAX = 5;
    const tooMany = labels.length > MAX;
    const renderList = tooMany ? labels.slice(0, MAX) : labels;

    const wrapper = document.createElement('span');
    wrapper.className = 'bc-second-crumb';
    wrapper.setAttribute('data-base-text', baseText);
    wrapper.append(document.createTextNode(baseText));

    if (renderList.length) {
      wrapper.append(document.createTextNode(' — '));
      renderList.forEach((label, i) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bc-filter-chip';
        chip.setAttribute('aria-label', `Open level at ${label}`);
        chip.textContent = label;

        // atrodam precīzo source (pēc pozīcijas secībā)
        let seenSame = -1;
        const src = sources.find(s => {
          if (s.label === label) {
            seenSame++;
            return seenSame === 0;
          }
          return false;
        });

        chip.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!src) return;

          const idxOfThis = sources.findIndex(s => s.label === src.label && s.type === src.type && s.el === src.el);

          if (CASCADE_CLEAR) {
            // NOŅEMAM TIKAI TOS, KAS NĀK PĒC ŠĪ (pa labi) — pašu klikšķoto un iepriekšējos atstājam
            for (let j = sources.length - 1; j > idxOfThis; j--) {
              triggerRemoveForSource(sources[j]);
            }
            // pašu NE noņemam
          } else {
            // klasiskais režīms: noņem tikai šo vienu
            triggerRemoveForSource(src);
          }
        });

        wrapper.appendChild(chip);
        if (i < renderList.length - 1) wrapper.append(document.createTextNode(' • '));
      });

      if (tooMany) {
        wrapper.append(document.createTextNode(' • '));
        const more = document.createElement('span');
        more.className = 'bc-filter-chip bc-filter-chip--more';
        more.textContent = `+${labels.length - MAX} more`;
        wrapper.appendChild(more);
      }
    }

    if (li) {
      li.innerHTML = '';
      li.appendChild(wrapper);
    } else {
      crumb2.replaceWith(wrapper);
    }

    wrapper.setAttribute('title', wrapper.textContent);
    const nav = bc.closest('nav');
    if (nav) nav.setAttribute('aria-label', 'Breadcrumb');

    log('updated (cascade:', CASCADE_CLEAR, '):', { baseText, labels });
  }

  // ---------- trigeri ----------
  function burstUpdate(times = 5, gap = 200) {
    let i = 0;
    const t = setInterval(() => { updateBreadcrumbs(); if (++i >= times) clearInterval(t); }, gap);
  }

  function setupObservers() {
    const results = document.getElementById('filter-results') ||
                    document.querySelector('.main-products-grid__results') ||
                    document.querySelector('[data-filters-results]');

    if (results && 'MutationObserver' in window) {
      const mo = new MutationObserver(() => burstUpdate(6, 150));
      mo.observe(results, { childList: true, subtree: true });
      log('MO bound on results');
    } else {
      log('MO: results not found – binding to body');
      if ('MutationObserver' in window) {
        const moBody = new MutationObserver((m) => {
          if ([...m].some(rec => (rec.target && (rec.target.id === 'filter-results' || (rec.target.classList && rec.target.classList.contains('main-products-grid__results')))))) {
            burstUpdate(6, 150);
          }
        });
        moBody.observe(document.body, { childList: true, subtree: true });
      }
    }

    ['facets:updated','filters:updated','collection:rendered','cc:filters:updated','cc:filters:applied','cc:filters:rendered']
      .forEach(evt => document.addEventListener(evt, () => burstUpdate(6, 150)));

    const _push = history.pushState, _replace = history.replaceState;
    history.pushState    = function() { _push.apply(history, arguments);    burstUpdate(6, 150); };
    history.replaceState = function() { _replace.apply(history, arguments); burstUpdate(6, 150); };
    window.addEventListener('popstate', () => burstUpdate(6, 150));

    document.addEventListener('click', (e) => {
      if (e.target.closest('.facets, .filters, [data-facet], .facet-option, .active-facets, .facets__form, .js-filter, [data-filter], .toolbar-filters')) {
        burstUpdate(8, 150);
      }
    });

    window.addEventListener('load', () => burstUpdate(8, 150));
  }

  document.addEventListener('DOMContentLoaded', function () {
    log('loaded');
    updateBreadcrumbs();
    setupObservers();
    setTimeout(updateBreadcrumbs, 600);
    setTimeout(updateBreadcrumbs, 2000);
  });
})();